<script setup>
import { useChatStore } from '@/stores/chat.store'

defineProps({
  quickReplies: {
    type: Object,
    required: true,
  },
  disable: {
    type: Boolean,
    default: false,
  },
})

const chatStore = useChatStore()
</script>

<template>
  <div class="row q-gutter-xs q-mt-sm">
    <q-chip
      v-for="item in quickReplies.items"
      :key="item.label"
      clickable
      :outline="!chatStore.isQuickReplySelected(item)"
      color="primary"
      :text-color="chatStore.isQuickReplySelected(item) ? 'white' : 'primary'"
      :icon="chatStore.isQuickReplySelected(item) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"
      :disable="disable"
      class="chat-quick-reply"
      @click="chatStore.toggleQuickReply(item)"
    >
      {{ item.label }}
      <q-tooltip>{{ item.message }}</q-tooltip>
    </q-chip>
  </div>
</template>

<style scoped lang="scss">
.chat-quick-reply {
  height: auto;
  min-height: 2em;
  max-width: 100%;
  padding-top: .25rem;
  padding-bottom: .25rem;

  :deep(.q-chip__content) {
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.3;
  }
}
</style>
